
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
      Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }
  // if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    // if(window.flitsObjects.allCssJs.socialLoginJs){
      Flits.LoadStyleScript('cartJs',window.flitsObjects.allCssJs.cartJs.url);
  //   }
  // // }
  if(Flits.Metafields.IS_STORE_CREDIT_PAID && Flits.Metafields.is_store_credit_enable && window.flitsObjects.storeData.customer_id != -1){
    document.addEventListener('click', function(event) {
            var flits_credit_added_attr = Flits(event.target).attr("data-flits");
            console.log(flits_credit_added_attr)
                if (typeof flits_credit_added_attr !== 'undefined' && flits_credit_added_attr == 'store-credit-added') {
                var submitBtn = event.target;
                return Flits.setupcheckoutProcess.apply(Flits.StoreCreditCart, [event, submitBtn]);          
                }
    }, true);
  }
  Flits.extend({
    redirectToCheckout: async function (parameters) {
      parameters = parameters || {};
      var form = Flits(Flits.StoreCreditCart.settings.checkoutFormSelectors.join(','));
      if (form.length <= 0) {
        // location.href = "/checkout?" + Flits.param(parameters);   
        location.href = location.origin+"/discount/"+parameters?.discount+"?redirect=/checkout";
        return true;
      }
      fetch(`/discount/${parameters?.discount}`)
        .then(function() {
            var form_action = form.attr("action");
            var form_action_data = Flits.parseURL(form_action);
      
            Flits.each(parameters, function (index, item) {
              var existing = form.find("[name='" + index + "']");
              if (existing.length <= 0) {
                form.append("<input type='hidden' name='" + index + "' value='" + item + "'>");
              } else {
                existing.val(item);
              }
              if (form_action_data.searchObject[index]) {
                form_action = form_action.replace(index + '=' + form_action_data.searchObject[index], item);
              } else {
                form_action += (form_action.indexOf('?') !== -1 ? "&" : "?") + index + "=" + item;
              }
            });
            form.append("<input type='hidden' name='checkout' value='true'>");
            form.attr("action", form_action);
            form.trigger('submit', [{ flitsFormSubmitted: true }]);
      });
    }
  })

  function thankyou_page(data, total_orders) {
    var pro_para = Flits('<p>',{class: 'prod_order_text'});
    // var pro_img = $('<img>', {
    //     src: 'https://cdn.shopify.com/s/files/1/0257/3333/3066/files/right_new1.png',
    //     height: '15px',
    //     width: '15px'
    // });
    var pro_img = $('<svg width="15" height="15" viewBox="0 0 150 150" fill="none" xmlns="http://www.w3.org/2000/svg"><circle fill="#4A725A" cx="75" cy="75" r="75"/><path d="M98.8202 68.0483C98.3592 67.5841 97.8489 67.1922 97.3188 66.8515L63.1793 35.6019C59.7073 32.1333 54.0805 32.1316 50.6069 35.6035C47.135 39.0738 47.135 44.7023 50.6069 48.1759L79.811 74.4884L50.6052 101.502C47.1316 104.971 47.1316 110.601 50.6052 114.075C52.342 115.808 54.6155 116.676 56.8889 116.676C59.1624 116.676 61.4408 115.808 63.1726 114.072L97.3188 82.1253C97.8489 81.7846 98.3576 81.3944 98.8202 80.9285C100.598 79.1506 101.451 76.8162 101.412 74.4884C101.453 72.159 100.598 69.8213 98.8202 68.0483Z" fill="white"/></svg>');
    pro_para.css('padding','0');
    pro_img.css('padding-right','5px');
    pro_para.append(pro_img);
    for(let i=0;i<data.length;i++){
      let credit_value=0;
      if(data[i].module_on=="order_number"){
        credit_value = parseInt(data[i].credits)/100;
        if(total_orders>=data[i].column_value && data[i].relation==">="){
          if(data[i].is_fixed){
            Flits("#fixed_para_val").text(credit_value);
            let append_div = Flits(".flits_status_div .fixed_para");
            Flits(".flits-order-credit-row").append(append_div);
            if(Flits.customer_id && window.location.pathname.startsWith("/products")){
              order_pro_para=pro_para.clone();
              let current_balance = Flits("#header_credit").text();
              order_pro_para.append("You will earn "+credit_value+" credit on your next order");
              pro_para.append("Your current balance is "+current_balance);
              Flits(".save_reward").append(pro_para);
              Flits(".save_reward").append(order_pro_para);
            }
          }
          else{
            Flits("#per_para_val").text(credit_value);
            let append_div = Flits(".flits_status_div .per_para");
            Flits(".flits-order-credit-row").append(append_div);
            if(Flits.customer_id && window.location.pathname.startsWith("/products")){
              order_pro_para=pro_para.clone();
              let current_balance = Flits("#header_credit").text();
              order_pro_para.append("You will earn "+credit_value+"% of credit on your next order value");
              pro_para.append("Your current balance is "+current_balance);
              Flits(".save_reward").append(pro_para);
              Flits(".save_reward").append(order_pro_para);
            }
          }
          return;
        }
        if(total_orders==data[i].column_value && data[i].relation=="=="){
          if(data[i+1] && data[i+1].module_on=="order_number"){
            credit_value = parseInt(data[i+1].credits)/100;
            if(data[i+1].is_fixed){
              Flits("#fixed_para_val").text(credit_value);
              let append_div = Flits(".flits_status_div .fixed_para");
              Flits(".flits-order-credit-row").append(append_div);
              if(Flits.customer_id && window.location.pathname.startsWith("/products")){
                order_pro_para=pro_para.clone();
                let current_balance = Flits("#header_credit").text();
                order_pro_para.append("You will earn "+credit_value+" credit on your next order");
                pro_para.append("Your current balance is "+current_balance);
                Flits(".save_reward").append(pro_para);
                Flits(".save_reward").append(order_pro_para);

              }
            }
            else{
              Flits("#per_para_val").text(credit_value);
              let append_div = Flits(".flits_status_div .per_para");
              Flits(".flits-order-credit-row").append(append_div);
              if(Flits.customer_id && window.location.pathname.startsWith("/products")){
                order_pro_para=pro_para.clone();
                let current_balance = Flits("#header_credit").text();
                order_pro_para.append("You will earn "+credit_value+"% of credit on your next order value");
                pro_para.append("Your current balance is "+current_balance);
                Flits(".save_reward").append(pro_para);
                Flits(".save_reward").append(order_pro_para);

              }
            }
          }
          return;
        }
        if((total_orders+1)==data[i].column_value){
          if(data[i+1] && data[i+1].module_on=="order_number"){
            credit_value = parseInt(data[i+1].credits)/100;
            if(data[i+1].is_fixed){
              Flits("#fixed_para_val").text(credit_value);
              let append_div = Flits(".flits_status_div .fixed_para");
              Flits(".flits-order-credit-row").append(append_div);
              if(Flits.customer_id && window.location.pathname.startsWith("/products")){
                order_pro_para=pro_para.clone();
                let current_balance = Flits("#header_credit").text();
                order_pro_para.append("You will earn "+credit_value+" credit on your next order");
                pro_para.append("Your current balance is "+current_balance);
                Flits(".save_reward").append(pro_para);
                Flits(".save_reward").append(order_pro_para);

              }
            }
            else{
              Flits("#per_para_val").text(credit_value);
              let append_div = Flits(".flits_status_div .per_para");
              Flits(".flits-order-credit-row").append(append_div);
              if(Flits.customer_id && window.location.pathname.startsWith("/products")){
                order_pro_para=pro_para.clone();
                let current_balance = Flits("#header_credit").text();
                order_pro_para.append("You will earn "+credit_value+"% of credit on your next order value");
                pro_para.append("Your current balance is "+current_balance);
                Flits(".save_reward").append(pro_para);
                Flits(".save_reward").append(order_pro_para);
              }
            }
            return;
          }
        }
      }
    }
  }

  Flits(document).on("Flits:orderStatusPage:storeCredit:AjaxSuccessful", function (event) {
    var total_order_no = window.flitsCustomerobject.customer.order_count;
    if(Flits.customer_id!=-1){
      Flits.ajax({
        type: "POST",
        url: Flits.base_url + '/' + Flits.customer_id + '/get_rule',
        data: {
          customer_hash: Flits.newCustomerHash,
          token: Flits.token,
        },
      }).done((function(resp) {
        var data = resp.rules.all_rules_data;
        thankyou_page(data, total_order_no);
      }))
    }
  });

  if(Flits.customer_id && window.location.pathname.startsWith("/products")){
    var total_order_no = window.flitsCustomerobject.customer.order_count;
    if(Flits.customer_id!=-1){
      Flits.ajax({
        type: "POST",
        url: Flits.base_url + '/' + Flits.customer_id + '/get_rule',
        data: {
          customer_hash: Flits.customerHash,
          token: Flits.token,
        },
      }).done((function(resp) {
        var data = resp.rules.all_rules_data;
        thankyou_page(data, total_order_no);
      }))
    }
  }

  if(Flits.customer_id!=-1){
    Flits.ajax({
      method: "GET",
      url: Flits.base_url + '/' + Flits.customer_id + "/credit/get_credit",
      data: {
        customer_hash: Flits.customerHash,
        token: Flits.token
      }
    }).done((function(resp) {
      var data = resp;
      Flits(".tab-body #header_credit").html(Flits.formatMoney(Math.abs(data.customer.credits),Flits.money_format));
    }))
  }

  Flits(document).on("click", ".flits-profile-save-button", function (event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    let error = false;
    let errorDiv = '<div class="flits-custom-error">*This field is required</div>';
    Flits('.flits-custom-error').remove();
    if(Flits("#flits-form-profile").find("input[name='birthdate']").val()==''){
      error = true;
      var errorAppend = Flits("input[name='birthdate']").parent('.flits-input-wrap');
      Flits(errorDiv).insertAfter(errorAppend);
    }
    if(error == false){
      form.submit();
    }
  });
  Flits(document).on("click", ".flits-profile-cancel-button", function (event) {
    if(Flits('.flits-custom-error')){Flits('.flits-custom-error').remove();}
  });

  Flits(document).on("click", ".flits_profile_progress .profile-circle", function (params) {
    window.location.pathname="/account";
  })

  Flits(document).ready(function() {
    var pro_completion = 0;
    function updateProgressBar(percentage) {
      var radius = Flits('.bar').attr('r');
      var circumference = 2 * Math.PI * radius;
      var offset = circumference - (percentage / 100) * circumference;
      
      Flits('.bar').css('stroke-dasharray', circumference);
      Flits('.bar').css('stroke-dashoffset', offset);
      Flits('.percentage').text(percentage + '%');
    }

    if(window.flitsCustomerobject.customer.first_name){pro_completion++}
    if(window.flitsCustomerobject.customer.last_name){pro_completion++}
    if(window.flitsCustomerobject.customer.email){pro_completion++}
    if(window.flitsCustomerobject.customer.phone){pro_completion++}
    if(window.flitsCustomerobject.customer.birthdate){pro_completion++}
    if(window.flitsCustomerobject.customer.gender){pro_completion++}
    if(window.flitsCustomerobject.customer.address>0){pro_completion++}

    pro_completion = pro_completion*14;
    if(pro_completion>90){pro_completion=100;}
    
    updateProgressBar(pro_completion);
  });

  Flits(document).on("Flits:AccountPage:Visible", function(){
      Flits(".flits-account-page-content a[href$='/account/logout']").attr("data-no-instant", "");
    }); 
  
}(Flits));
